import { Component, Injector, Input, ViewChild } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { GridComponent } from 'src/app/components/grid/grid.component';
import { InputTextareaComponent } from 'src/app/components/input/input-textarea/input-textarea.component';
import { PageFrameBase } from '../../base/page-frame-base';
import { ChecklistOrigem, ChecklistService } from './checklist.service';
import { AtividadeDaoService } from 'src/app/dao/atividade-dao.service';
import { Checklist } from 'src/app/models/atividade.model';
import { IIndexable } from 'src/app/models/base.model';
import { BadgeButton } from 'src/app/components/badge/badge.component';
import { EditorService } from 'src/app/services/editor.service';

@Component({
  selector: 'checklist',
  templateUrl: './checklist.component.html',
  styleUrls: ['./checklist.component.scss']
})
export class ChecklistComponent extends PageFrameBase {
  @ViewChild('texto', { static: false }) public texto?: InputTextareaComponent;
  @ViewChild('checklist', { static: false }) public checklist?: GridComponent;
  @Input() set items(value: Checklist[]) {
    if (this._items != value) this._items = value;
    this.detectChanges();
  }
  get items(): Checklist[] {
    return this._items;
  }
  @Input() set origem(value: ChecklistOrigem) {
    if (this._origem != value) {
      this._origem = value;
    }
  }
  get origem(): ChecklistOrigem {
    return this._origem;
  }
  @Input() set modelo(value: any | undefined) {
    if (this._modelo != value) {
      this._modelo = value;
    }
  }
  get modelo(): any {
    return this._modelo;
  }

  private _origem: ChecklistOrigem = undefined;
  private _items: Checklist[] = [];
  private _modelo: any;

  public checklistService: ChecklistService;
  public checklistModelo: Checklist[] = [];
  public titulo: string = '';
  public descricao: string = '';
  public form: FormGroup;
  public formCheckItem: FormGroup;
  public editorService:EditorService;

  constructor(public injector: Injector) {
    super(injector);
    this.checklistService = injector.get<ChecklistService>(ChecklistService);
    this.editorService = injector.get<EditorService>(EditorService);
    this.form = this.fh.FormBuilder({});
    this.formCheckItem = this.fh.FormBuilder({
      id: { default: '' },
      checked: { default: false },
      texto: { default: "" },
      detalhamento: { default: "" },
      anotacoes: { default: "" }
    }, this.cdRef, this.validate);
  }

  ngOnInit() {
    super.ngOnInit();
    if (this.metadata) {
      this.origem = (this.metadata!.origem || this.origem) as ChecklistOrigem;
      this.entity = this.metadata!.entity;
      this.descricao = this.origem === "ATIVIDADE" ? this.entity?.descricao : '';
      this.items = this.entity!.checklist || [];
    }
    switch (this.origem) {
      case 'ATIVIDADE': {
        this.dao = this.injector.get<AtividadeDaoService>(AtividadeDaoService);
        this.modelo = this.entity?.tipo_atividade;
        this.titulo = this.lex.translate('Atividade');
      }
    }
    this.checklistModelo = this.checklistService?.buildChecklist(this.modelo);
  }

  ngOnChanges(): void {
    this.checklistModelo = this.checklistService?.buildChecklist(this.modelo);
  }

  public validate = (control: AbstractControl, controlName: string) => {
    let result = null;
    if (controlName == "texto" && !control.value?.length) {
      result = "Não pode ser em branco";
    }
    return result;
  }

  public addCheckItem = async () => {
    return this.checklistService.addItemHandleChecklist(this.formCheckItem);
  }

  public async saveCheckItem(form: FormGroup, item: any) {
    return Object.assign(this.checklist!.editingRow!, form.value);
  }

  public saveData(form: IIndexable): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.entity.checklist = this.items;
      this.dao?.update(this.entity.id, { checklist: this.entity.checklist }).then(resposta => {
        resolve(true)
      }, error => reject(error));
    });
  }

  public statusChecklist(): BadgeButton {
    const checklistModelo: Checklist[] = this.checklistModelo?.sort((a: Checklist, b: Checklist) => (a.texto < b.texto) ? -1 : 1);
    const checklistEntity: Checklist[] = this.items?.sort((a: Checklist, b: Checklist) => (a.texto < b.texto) ? -1 : 1);
    if (!checklistModelo.length) return { color: "warning", hint: "A atividade não está relacionada a nenhum modelo (Tipo de Atividade)", icon: "bi bi-check2", label: "Não vinculado" };
    if (checklistModelo?.map(x => x.texto).toString() === checklistEntity?.map(x => x.texto).toString())
      return { color: "primary", hint: "O checklist da atividade está idêntico ao do seu modelo (Tipo de Atividade)", icon: "bi bi-journal-check", label: "Íntegro" };
    else return { color: "danger", hint: "O checklist da atividade está diferente do checklist do seu modelo (Tipo de Atividade)", icon: "bi bi-exclamation-triangle", label: "Modificado" };
  }
}
